import { catchAsync } from './index.js';
import UserAPI from './user.js';

class IngredientAPIService {
    getByPage = catchAsync(async (page = 1, limit = 10) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/ingredients?page=${page}&limit=${limit}`);

        const data = await res.json();
        return data;
    });

    search = catchAsync(async (keyword, page = 1, limit = 10) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/search/ingredients?keyword=${encodeURIComponent(keyword)}&page=${page}&limit=${limit}`);

        const data = await res.json();
        return data;
    });

    getOne = catchAsync(async (uri) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/ingredients/${uri}`);

        const data = await res.json();
        return data;
    });

    create = catchAsync(async (ingredient) => {
        const token = UserAPI.getUserToken();

        if (!token) {
            return null;
        }

        const res = await fetch(`${process.env.REACT_APP_API_URL}/ingredients/create`, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(ingredient),
        });

        const data = await res.json();
        return data;
    });

    edit = catchAsync(async (id, ingredient) => {
        const token = UserAPI.getUserToken();

        if (!token) {
            return null;
        }

        const res = await fetch(`${process.env.REACT_APP_API_URL}/ingredients/update/${id}`, {
            method: "PUT",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(ingredient),
        });

        const data = await res.json();
        return data;
    });

    delete = catchAsync(async (id) => {
        const token = UserAPI.getUserToken();

        if (!token) {
            return null;
        }

        const res = await fetch(`${process.env.REACT_APP_API_URL}/ingredients/delete/${id}`, {
            method: "DELETE",
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        });

        const data = await res.json();
        return data;
    });
}

const IngredientAPI = new IngredientAPIService();
export default IngredientAPI;